export const steps = [
  {
    selector: ".first-step", // meeting Dashboard stepNumber = 0
    content: (
      <>
        <h3>Dashboard :</h3>This meeting dashboard will show you all of your
        meetings. You can search for them by name.
      </>
    ),
  },
  {
    selector: ".second-step", // upload meeting stepNumber = 1
    content: (
      <>
        <h3>Manual Upload :</h3> You can upload your content using the upload
        button. We allow Mp4 and M4a formats.
      </>
    ),
  },
  {
    selector: ".third-step", // upload meeting tools integrations stepNumber = 2
    content: (
      <>
        {" "}
        <h3>Auto Upload (Zoom & Webex) :</h3>
        Step 1: Integrate either Zoom or Webex.
        <br />
        <br /> Step 2: During your next meeting, record it to the cloud (link).
        If you don't have this option, record it locally (link). <br />
        <br /> Step 3: either upload your local meeting recording, or if you
        integrated zoom/webex then your cloud meeting recording will be
        automatically imported.
        <br />
        <br /> Step 4: Once you receive an email that your meeting notes are
        ready, you can find and click on the meeting on your dashboard to view
        summaries, action items, and sentiment analysis.
        <br />

      </>
    ),
  },
  {
    selector: ".fourth-step", // project management tools integrations stepNumber = 3
    content: (
      <>
        <h3>Project Management Tools :</h3>Additional integrations are available
        to export your meeting data (action items and summaries) to your favorite tools automatically.

      </>
    ),
  },
  {
    selector: ".fivth-step", // three dots on each meeting stepNumber = 4
    content: (
      <>
        <h3>Meeting Settings :</h3>For each meeting imported, you can click on
        the dropdown that will show you some quick actions you can perform on
        your meeting.
      </>
    ),
  },
  {
    selector: ".seventh-step", // on first meeting in dashboard stepNumber = 5
    content: (
      <>
        <h3>Meeting :</h3> Each uploaded or shared meeting will be displayed
        like this. You can edit its name here. Clicking on this row will open up the page to show the full meeting content.
      </>
    ),
  },
  {
    selector: ".eigth-step", // Recording stepNumber = 6
    content: (
      <>
        <h3>Recording:</h3>
        Below is original meeting recording that was uploaded. You can watch the
        whole meeting here.
        <br />
        <h3>Meeting Details:</h3>
        At the end you can see the Host (who uploaded that meeting), name and
        download option.
      </>
    ),
  },
  {
    selector: ".ninth-step", // Share stepNumber = 7
    content: (
      <>
        <h3>Share Meeting :</h3>
        Now, using the “Share” button in the dropdown menu, you should be able
        adjust the people with whom your meetings are shared. Feel free to share
        your meetings with your team members.Only host of meeting can share the
        meeting.
      </>
    ),
  },
  {
    selector: ".tenth-step", // TodoList, Summary & Sentiments stepNumber = 8
    content: (
      <>
        <h3>TodoList, Summary & Sentiments:</h3>Using the tabs here, you can
        switch between action items for the meeting, a detailed summary, and
        sentiment analysis
      </>
    ),
  },
  {
    selector: ".eleventh-step", // Overview & Transcript stepNumber = 9
    content: (
      <>
        <h3>Overview & Transcript:</h3>Using the tabs here, you can switch
        between a quick meeting summary and a full transcript.
      </>
    ),
  },
  {
    selector: ".twelth-step", // Account settings stepNumber = 10
    content: (
      <>
        <h3>Account settings:</h3> You can also edit your account settings like
        username, password, integrations and subscription by clicking on the
        drop down under account settings.{" "}
      </>
    ),
  },

  // ...
];
